export default {
  SHOW_GLOBAL_ALERT : 'SHOW_GLOBAL_ALERT',
  UPDATE_TRANSLATIONS_RESOURCE : 'UPDATE_TRANSLATIONS_RESOURCE',


  // 倒计时
  UPDATE_COUNTING_DOWN_STATUS           : 'UPDATE_COUNTING_DOWN_STATUS',
  UPDATE_COUNTDOWN_START_TIME           : 'UPDATE_COUNTDOWN_START_TIME',
}
